import * as React from "react";
import { NavigationCtx } from "../context/NavigationContext";

const useNavigation = () => React.useContext(NavigationCtx);

export default useNavigation;
